/**
 * @file maternalTraitsProficiency.js
 * @author Jake Stark
 * @desc maternalTraitsProficiency report plugin

*/

/**
 * @module maternalTraitsProficiency 
 * @desc maternalTraitsProficiency report plugin
 */

define('plugins/maternalTraitsProficiency',["underscore",
        "models", "cardboard/models", "cardboard/collections", "cardboard/util", "cardboard/pluginPieces",
        "text!plugins/templates/maternalTraitsProf_profByEd_table.html!strip", "text!plugins/templates/maternalTraitsProf_profByMaternal_table.html!strip", "text!plugins/templates/maternalTraitsProf_profByPrenatal_table.html!strip"
    ],
    function (_,
        ECLDSModels, CardboardModels, CardboardCollections, Util, PluginPieces,
        profByEdTemplate, profByMaternalTemplate, profByPrenatalTemplate) {

        console.log("MODULE: maternalTraitsProficiency");

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                orgDetailPane: false,
                noMapSearch: true,
                noOrgFinderSchool: true,
                orgFinderDistrict: true,
                forcedSummaryFilters: ["FISCAL_YEAR", "SUBJECT", "RACE_ETHTYPE"],
                definitionsECLDS: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                title: "3rd Grade Proficiency by Maternal Education ",
                explanationText: "<p>This chart shows the percent of public school 3rd grade children proficient in either Reading or Math (dependent on the filter selected) by maternal education. </p><p>Maternal Education is mother's educational attainment at the time of child's birth, data is identified in the child's birth record. Maternal Education is unknown for children born outside of Minnesota or children who were missing this data on their birth record (e.g. no birth data available).</p><p> The proficiency tests given in 3rd grade are the Minnesota Comprehensive Assessment (MCA) and Minnesota Test of Academic Skills (MTAS). In 2011 math test standards changed and in 2013 reading test standards changed. No comparisons should be made with data before and after the changes. Children who did not take the proficiency test are not included in this chart or the statewide average. </p>",
                openByDefault: true,
                views: [{
                    type: "template",
                    template: "<p class='red'>Due to COVID-19, no 2020 summarized assessment data for MCA or MTAS is available.</p> <p>NOTE: Maternal Education is mother's educational attainment at the time of child's birth.  </p><p>NOTE: For the 2020-21 school year, the participation rates for both math and reading assessments in 3rd grade was 85%. Historically, the participation rates were higher than 95%. Visit the Minnesota Report Card for more information about 3rd graders’ <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--R__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>reading test participation</a> or <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--M__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>math test participation</a> in your area. </p><button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.nextSibling.children[0].id);'>Export to PDF</button>"
                },
                {
                    type: "template",
                    template: "<h5 class='chartHead'>{{data.heading3}}</h5>",
                    dataSourceName: "data",
                    dataPath: "dataSets.thirdGradeProficiencyByMaternalEducation"
                },
                {
                    // SETUP
                    type: "stackedColumn",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByMaternalEducation",

                    // "pointsAcrossRows": given that the data is
                    // two-dimensional (meaning an array of arrays, or
                    // similar structure, implying that we have more than
                    // one series to plot) each series is contained in a
                    // "column", like so:
                    //   +---------+
                    //   | X . . . |
                    //   | X . . . |
                    //   | X . . . |
                    //   | X . . . |
                    //   +---------+
                    // To wrap your head around this, watch iteration in your debugger in
                    // pointsAcrossRows() in transforms.js.
                    dataShape: "pointsAcrossRows",
                    convertDataHashToArray: true,
                    dataDimensions: 2,
                    unitDec: 1,
                    title: "",
                    lineData: true,
                    lineSpan: 3.4,
                    pointWidth: 45,

                    // DISPLAY
                    xAxisLabelPath: "maternalEducation",
                    legendReversed: false,
                    unitString: "%",
                    exportToPDF: true,
                    hideContext: true,
                    stackLabels: false,
                    minorTickInterval: 'auto',
                    minorGridLineColor: '#C5EEFA',
                    showLegend: true,
                    disableLegendClick: false,

                    // SERIES (only one series, this is a simple graph)
                    series: [{
                        valuePath: "proficiency[0].percent",
                        seriesDisplayName: "Not Proficient",
                        //    color: "orange"

                    }, {
                        valuePath: "proficiency[1].percent",
                        seriesDisplayName: "Proficient",
                        //   color: "purple"
                    }],
                    errorConditions: [PluginPieces.standardErrorCondition]
                }, {
                    type: "template",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByMaternalEducation",
                    template: profByEdTemplate,
                    errorConditions: [PluginPieces.silentStandardErrorCondition]
                }, {
                    type: "template",
                    template: "<span class='red'>{{data.heading}}</span><div id='stateData' style='display:none'>{{data.headingHover}}</div>",
                    dataSourceName: "data",
                    dataPath: "dataSets.thirdGradeProficiencyByMaternalEducation"
                }, ]
            }, {
                title: "3rd Grade Proficiency by Maternal Age ",
                explanationText: "<p>This chart shows the percent of public school 3rd grade children proficient in either Reading or Math (dependent on the filter selected) by maternal age. Maternal age is the mother's age at the time of the child's birth. </p><p>Maternal age comes from the child's birth record and is unknown for children born outside of Minnesota or children who were missing this data on their birth record (e.g. no birth data available).</p><p> The proficiency tests given in 3rd grade are the Minnesota Comprehensive Assessment (MCA) and Minnesota Test of Academic Skills (MTAS). In 2011 math test standards changed and in 2013 reading test standards changed. No comparisons should be made with data before and after the changes. Children who did not take the proficiency test are not included in this chart or the statewide average.</p> ",
                openByDefault: false,
                views: [{
                    type: "template",
                    template: "<p class='red'>Due to COVID-19, no 2020 summarized assessment data for MCA or MTAS is available.</p> <p>NOTE: Maternal age is the mother's age at the time of the child's birth.  </p><p>NOTE: For the 2020-21 school year, the participation rates for both math and reading assessments in 3rd grade was 85%. Historically, the participation rates were higher than 95%. Visit the Minnesota Report Card for more information about 3rd graders’ <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--R__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>reading test participation</a> or <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--M__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>math test participation</a> in your area. </p> <button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.nextSibling.children[0].id);'>Export to PDF</button>"
                },
                {
                    type: "template",
                    template: "<h5 class='chartHead'>{{data.heading3}}</h5>",
                    dataSourceName: "data",
                    dataPath: "dataSets.thirdGradeProficiencyByMaternalAge"
                },
                 {
                    // SETUP
                    type: "stackedColumn",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByMaternalAge",

                    // "pointsAcrossRows": given that the data is
                    // two-dimensional (meaning an array of arrays, or
                    // similar structure, implying that we have more than
                    // one series to plot) each series is contained in a
                    // "column", like so:
                    //   +---------+
                    //   | X . . . |
                    //   | X . . . |
                    //   | X . . . |
                    //   | X . . . |
                    //   +---------+
                    // To wrap your head around this, watch iteration in your debugger in
                    // pointsAcrossRows() in transforms.js.
                    dataShape: "pointsAcrossRows",
                    convertDataHashToArray: true,
                    dataDimensions: 2,
                    unitDec: 1,
                    title: "",
                    lineData: true,
                    lineSpan: 4.4,
                    pointWidth: 45,

                    // DISPLAY
                    xAxisLabelPath: "maternalAge",
                    legendReversed: false,
                    unitString: "%",
                    exportToPDF: true,
                    hideContext: true,
                    stackLabels: false,
                    minorTickInterval: 'auto',
                    minorGridLineColor: '#C5EEFA',
                    showLegend: true,
                    disableLegendClick: false,

                    // SERIES (only one series, this is a simple graph)
                    series: [{
                        valuePath: "proficiency[0].percent",
                        seriesDisplayName: "Not Proficient",
                        //  color: "orange"
                    }, {
                        valuePath: "proficiency[1].percent",
                        seriesDisplayName: "Proficient",
                        //   color: "purple"
                    }],
                    errorConditions: [PluginPieces.standardErrorCondition]
                }, {
                    type: "template",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByMaternalAge",
                    template: profByMaternalTemplate,
                    errorConditions: [PluginPieces.silentStandardErrorCondition]
                }, {
                    type: "template",
                    template: "<span class='red'>{{data.heading}}</span>",
                    dataSourceName: "data",
                    dataPath: "dataSets.thirdGradeProficiencyByMaternalAge"
                }, ]
            }, {
                title: "3rd Grade Proficiency by Prenatal Care Utilization",
                explanationText: " <p>This chart shows the percent of public school 3rd grade children proficient in either Reading or Math (dependent on the filter selected) by Mother's Prenatal Care Utilization. </p><p>Prenatal Care Utilization is measured using the Adequacy of Prenatal Care Utilization (APNCU) Index--or Kotelchuck Index-- also known as The Kotelchuck Index. This index is based on the initiation of prenatal services and the number of prenatal visits from when prenatal care began until delivery. A more detailed description can be found in the glossary of the ‘For More Information' tab below. Mother's Prenatal Care Utilization comes from the child's birth record and is unknown for children born outside of Minnesota or for children who were missing this data on their birth record (e.g. no birth data available).</p><p> The proficiency tests  given in 3rd grade are the Minnesota Comprehensive Assessment (MCA) and Minnesota Test of Academic Skills (MTAS). In 2011 math test standards changed and in 2013 reading test standards changed. No comparisons should be made with data before and after the changes. Children who did not take the proficiency test are not included in this chart or the statewide average.</p> ",
                openByDefault: false,
                views: [{
                    type: "template",
                    template: "<p class='red'>Due to COVID-19, no 2020 summarized assessment data for MCA or MTAS is available.</p><p>NOTE: Prenatal Care Utilization is measured using the Adequacy of Prenatal Care Utilization (APNCU) Index--or Kotelchuck Index-- also known as The Kotelchuck Index. This index is based on the initiation of prenatal services and the number of prenatal visits from when prenatal care began until delivery.  </p><p>NOTE: For the 2020-21 school year, the participation rates for both math and reading assessments in 3rd grade was 85%. Historically, the participation rates were higher than 95%. Visit the Minnesota Report Card for more information about 3rd graders’ <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--R__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>reading test participation</a> or <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--M__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>math test participation</a> in your area. </p> <button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.nextSibling.children[0].id);'>Export to PDF</button>"
                },
                {
                    type: "template",
                    template: "<h5 class='chartHead'>{{data.heading3}}</h5>",
                    dataSourceName: "data",
                    dataPath: "dataSets.thirdGradeProficiencyByPrenatalCareUtilization"
                },
                {
                    // SETUP
                    type: "stackedColumn",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByPrenatalCareUtilization",

                    // "pointsAcrossRows": given that the data is
                    // two-dimensional (meaning an array of arrays, or
                    // similar structure, implying that we have more than
                    // one series to plot) each series is contained in a
                    // "column", like so:
                    //   +---------+
                    //   | X . . . |
                    //   | X . . . |
                    //   | X . . . |
                    //   | X . . . |
                    //   +---------+
                    // To wrap your head around this, watch iteration in your debugger in
                    // pointsAcrossRows() in transforms.js.
                    dataShape: "pointsAcrossRows",
                    convertDataHashToArray: true,
                    dataDimensions: 2,
                    unitDec: 1,
                    title: "",
                    lineData: true,
                    lineSpan: 3.4,
                    pointWidth: 45,

                    // DISPLAY
                    xAxisLabelPath: "careUtilization",
                    legendReversed: false,
                    unitString: "%",
                    exportToPDF: true,
                    hideContext: true,
                    stackLabels: false,
                    minorTickInterval: 'auto',
                    minorGridLineColor: '#C5EEFA',
                    showLegend: true,
                    disableLegendClick: false,

                    // SERIES (only one series, this is a simple graph)
                    series: [{
                        valuePath: "proficiency[0].percent",
                        seriesDisplayName: "Not Proficient",
                        //  color: "orange"
                    }, {
                        valuePath: "proficiency[1].percent",
                        seriesDisplayName: "Proficient",
                        //  color: "purple"
                    }],
                    errorConditions: [PluginPieces.standardErrorCondition]
                }, {
                    type: "template",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByPrenatalCareUtilization",
                    template: profByPrenatalTemplate,
                    errorConditions: [PluginPieces.silentStandardErrorCondition]
                }, {
                    type: "template",
                    template: "<span class='red'>{{data.heading}}</span>",
                    dataSourceName: "data",
                    dataPath: "dataSets.thirdGradeProficiencyByPrenatalCareUtilization"
                }, ]

            }, {
                title: "For More Information",
                visibleByDefault: true,
                openByDefault: false,
                views: [{
                    type: "template",
                    template: "<p> These charts show public school 3rd Grade children's attendance by maternal education, maternal age and prenatal care utilization.</p><p> Children attending private school are not included in these counts. There are some 3rd graders whom were not born in Minnesota so ECLDS does not know their outcomes at birth. </p><h2> Glossary</h2><p><strong> CTSTR</strong>: Counts Too Small To Report - when results are less than 10.<br/><strong> 3rd Grade Cohort</strong>: A group of children who participated in public 3rd grade in a given school year. <br/><b>No Data Available</b>: No data are available for the selected criteria.<br/><b> Proficient</b>: Students who are meeting or exceeding academic standards. <br/><b>Not Proficient</b>: Students not yet meeting academic standards. <br/><b>Prenatal Care Utilization</b>: Also called the Adequacy of Prenatal Care Utilization (APNCU) Index--or Kotelchuck Index-- measures the utilization of prenatal care based on two elements obtained from the birth record: 1) when prenatal care began (initiation) and 2) the number of prenatal visits from when prenatal care began until delivery (received services). </p><ul style='list-style-type: none; margin-block-start: 0;'><li style='list-style-type: none;'><b>Intensive Care</b>: Prenatal care begun by the 4th month of pregnancy and 110% or more of recommended visits received.  </li><li style='list-style-type: none;'><b>Adequate Care</b>: Prenatal care begun by the 4th month of pregnancy and 80-109% of recommended visits received.  </li><li style='list-style-type: none;'><b>Intermediate Care</b>: Prenatal care begun by the 4th month of pregnancy and 50-79% of recommended visits received.  </li><li style='list-style-type: none;'><b>Inadequate Care</b>: Prenatal care begun after the 4th month of pregnancy or less than 50% of recommended visits received.  </li><li style='list-style-type: none;'><b>No Care</b>: No prenatal care visits received. </li></ul><h2>Selection Criteria Definitions</h2><p><strong> School County</strong>: County of the location of public school of enrollment. <br/><strong>School District</strong>: School district in the state of Minnesota.<br/><strong> School Year</strong>: Period of time that covers July 1 of one year through June 30 of the following.<br/><b>Disability Type</b>: Disability type as identified within Minnesota's K-12 public school system. For 3rd Grade cohort analyses disability type originates in MDE data.<br/><b> Home Language</b>: A 3rd Grade cohort utilizes MDE home language types as defined in the MDE K12 data set. ECLDS provides the home language types containing 10 or more children. <br/><b>Subject - Reading</b>: Standards-based accountability assessments on the English/language arts reading standards in 3rd grade.<br/><b>Subject - Math</b>: Standards-based accountability assessments on the mathematics standards in 3rd grade. <br/><strong> Race/Ethnicity:</strong><ul style='margin-top: -7px; margin-bottom: -15px;'><li>Federal Race/Ethnicity categories are as reported by the child's education record and align with the federal <a href='https://www.govinfo.gov/content/pkg/FR-1997-10-30/pdf/97-28653.pdf' target='_blank'>Office of Management and Budget’s standards</a>.</li><li>State Race/Ethnicity categories are as follows:<ul style='padding-left: 1em;'><li  style='list-style: circle;'><strong>State (Minnesota) Definition of American Indian</strong>: A person having origins in any of the original peoples of North America and who maintains cultural identification through tribal affiliation or community recognition. Any student or descendant from a North American tribe, regardless of other racial backgrounds.</li><li  style='list-style: circle'><strong>State (Minnesota) Definition of Other Indigenous Peoples</strong>: A student whose only racial or ethnic identification is with the original peoples of Central or South America. A student who meets the federal definition of American Indian or Alaska Native but not the state definition of American Indian, which means they identify only with indigenous peoples from Central and South America.</li><li style='list-style: circle'>State (Minnesota) definitions of race/ethnicity other than American Indian and Other Indigenous Peoples align with federal categories</li></ul></li></ul> <br/><b>English Learner</b>: A classification for a student whose home language is other than English and who has been assessed as needing additional English language instruction anytime in kindergarten through 3rd grade. <br/><b> Free/Reduced Price Meals</b>: Food program offered through public schools for low-income children. Family income must be at 100% of Federal Poverty Guidelines for Reduced Price Meals. Students may have participated in the program anytime in kindergarten through 3rd grade.  <br/><b>Homeless</b>: Students flagged as homeless using the McKinney-Vento Definition anytime in kindergarten through 3rd grade. <br/><b>K-3 Special Education</b>: Students receiving special education services anytime in kindergarten through 3rd grade.<br/><b> MFIP/DWP in 3rd Grade</b>: Minnesota Family Investment Program (MFIP) Minnesota's Temporary Assistance to Needy Families (TANF) program. It helps families and pregnant women who have low income go to work and move toward financial stability. Counts include children receiving MFIP anytime during third grade. <br/><b>SNAP in 3rd  Grade</b>: Supplemental Nutrition Assistance Program, formerly known as Food Stamps, helps Minnesotans with low income get the food they need for nutritious and well-balanced meals. Counts include children receiving SNAP anytime during third grade. <br/><b>MFIP/DWP prior to 3rd  Grade</b>: Minnesota Family Investment Program (MFIP) Minnesota's Temporary Assistance to Needy Families (TANF) program. It helps families and pregnant women who have low income go to work and move toward financial stability. Counts include children receiving MFIP any time in their life prior to third grade. <br/><b>SNAP prior to 3rd  Grade</b>: Supplemental Nutrition Assistance Program, formerly known as Food Stamps, helps Minnesotans with low income get the food they need for nutritious and well-balanced meals. Counts include children receiving SNAP any time in their life prior to third grade. </p><p> For more information, open the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde034818&RevisionSelectionMethod=latestReleased&Rendition=primary'  target='_blank'>ECLDS Data Guide. </a></p>"
                }]
            }],

            filterSources: {
                orgs: {
                    modelType: ECLDSModels.ECLDSOrgList,
                    //url: "/data/state.json",
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_orgid_maternalTraitsProficiency.fex",
                    noViewParams: true,
                    enabled: true
                },
                filters: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    urls: {
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_maternalTraitsProficiency_EcoDevRegion.fex"
                    },
                    enabled: true,
                    noViewParams: false
                },
                filters2: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_fiscal_year.fex",
                    enabled: true,
                    modelType: CardboardModels.FilterData
                },

                filters3: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    /*  defaultParams: ["FISCAL_YEAR=2018"], */
                    urls: {
                        //filterForReport: "data/filters.json"
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_maternalTraitsProficiency.fex"
                    },

                    // specify the order of filters, by name (filterUrl in database terms)
                    filterOrder: ["GENDER", "DISABILITY_TYPE", "HOME_LANGUAGE", "OTHER_CRITERIA"],

                    enabled: true,
                    noViewParams: false
                },
                filters4: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    //    defaultParams: ["FISCAL_YEAR=2014"],
                    urls: {
                        //filterForReport: "data/filters.json"
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_maternalTraitsProficiency_nbr3.fex"
                    },

                    // specify the order of filters, by name (filterUrl in database terms)
                    // filterOrder: ["IDEA_COLLECTIONS", "ECSE_OUTCOMES", "MOMS_AGE_AT_CB", "MOMS_EDLVL_AT_CB", "CR"],

                    enabled: true,
                    noViewParams: false
                },

                demographicCategories: {
                    modelType: CardboardCollections.DemoCatProducer,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_maternalTraitsProficiency_nbr2.fex",
                    enabled: true
                }
            },

            dataSources: {
                data: {
                    modelType: CardboardModels.Model,
                    // url: "/data/mocks/preGradData.json",
                    // url: "/data/mocks/preGradData_statewide.json",
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_sec_h_maternaltraitsproficiency.fex",
                    yearPath: "meta.fiscalYear",
                    //  defaultParams: {
                    //	orgId: 999999000,
                    //      COHORTID: 2014
                    //	},
                    enabled: true,
                    errorConditions: [PluginPieces.standardErrorCondition]

                }

            }
        };

        return exports;
    });
